<template>
  <div class="view">
    <div class="content">
      <div class="condition">
        <div class="check_wrap">
          <el-radio-group v-model="formdata.check_type" @change="changetype" size="small">
            <el-radio-button
                    v-for="(item,index) in checktype"
                    :label="item.value"
                    :key="index"
            >{{item.label}}
            </el-radio-button>
          </el-radio-group>
        </div>
        <div class="search_wrap">
          <el-form :inline="true" :model="formdata" class="form-inline">
            <el-form-item>
              <el-cascader
                      placeholder="请选择分类"
                      :options="cateoptions"
                      expand-trigger="hover"
                      v-model="formdata.cat_id"
                      :props="defaultprops"
                      change-on-select
                      :show-all-levels="false"
                      size="small"
              ></el-cascader>
            </el-form-item>
            <el-form-item>
              <el-select clearable v-model="formdata.goods_type" placeholder="请选择商品类型" size="small">
                <el-option
                        v-for="(item,index) in goodstype"
                        :value="item.value"
                        :label="item.label"
                        :key="index"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item>
              <el-input v-model="formdata.name" placeholder="请输入商品名称" size="small">
                <el-button slot="append" icon="el-icon-search" @click="init" size="small"></el-button>
              </el-input>
            </el-form-item>
          </el-form>
        </div>
        <div class="other_wrap">
          <el-button type="primary" @click="addgoods" size="small">添加商品</el-button>
        </div>
      </div>
      <div class="table_wrap">
        <el-table :data="tableData" style="width: 100%" @selection-change="handleSelectionChange">
          <el-table-column type="selection" width="55"></el-table-column>
          <el-table-column label="商品图片" align="center">
            <template slot-scope="scope">
              <div class="td_img">
                <img :src="scope.row.goods_thumb" alt/>
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="goods_name" label="商品名称" align="center"></el-table-column>
          <el-table-column prop="cat_id" label="所属分类" align="center">
            <template slot-scope="scope">{{scope.row.cat_id.join(',')}}</template>
          </el-table-column>
          <el-table-column label="商品类别" align="center">
            <template slot-scope="scope">{{gettypelabel(scope.row.type)}}</template>
          </el-table-column>
          <el-table-column prop="shop_price" width="120" label="商品单价" align="center"></el-table-column>
          <el-table-column prop="base_sales" label="销量" align="center"></el-table-column>
          <el-table-column prop="goods_number" label="库存" align="center"></el-table-column>
          <el-table-column prop="unit" label="销售单位" align="center"></el-table-column>
          <el-table-column prop="create_time" width="120" label="创建时间" align="center"></el-table-column>
          <el-table-column prop="update_time" label="上架时间" align="center"></el-table-column>
          <el-table-column prop="order_desc" label="商品排序" align="center"></el-table-column>
          <el-table-column label="操作" width="180" align="center" fixed="right">
            <template slot-scope="scope">
              <el-button @click="edit(scope.row.id)" type="text" size="small">编辑</el-button>
              <el-button @click="copy(scope.row.id)" type="text" size="small">复制商品</el-button>
              <el-button @click="del(scope.row.id)" type="text" size="small">删除</el-button>
              <i
                      v-if="scope.row.is_sale===0"
                      class="el-icon-upload2 shelf_icon"
                      @click="putonshelves(scope.row.id)"
              ></i>
              <i
                      v-if="scope.row.is_sale===1"
                      class="el-icon-download shelf_icon"
                      @click="pulloffshelves(scope.row.id)"
              ></i>
            </template>
          </el-table-column>
        </el-table>
        <div class="table_oper">
          <el-button
                  :disabled="this.multipleSelection&&this.multipleSelection.length=== 0"
                  @click="batchaddtype"
          >批量添加到分类
          </el-button>
          <el-button
                  :disabled="this.multipleSelection&&this.multipleSelection.length=== 0"
                  @click="batchtransfertype"
          >批量转移到分类
          </el-button>
          <el-button
                  :disabled="this.multipleSelection&&this.multipleSelection.length=== 0"
                  @click="batchputonshelves"
          >批量上架
          </el-button>
          <el-button
                  :disabled="this.multipleSelection&&this.multipleSelection.length=== 0"
                  @click="batchpulloffshelves"
          >批量下架
          </el-button>
        </div>
        <div class="pag_wrap">
          <el-pagination
                  background
                  @current-change="pageIndexChange"
                  :page-size="page.pagesize"
                  :current-page="page.pageindex"
                  layout="total, prev, pager, next"
                  :total="page.total"
          ></el-pagination>
        </div>
      </div>
    </div>
    <chooseClassifyDialog
            :ids="ids"
            :type="type"
            flag="points"
            :visible.sync="chooseclassifydialog"
            v-if="chooseclassifydialog"
            @success="success"
    ></chooseClassifyDialog>
  </div>
</template>
<script>
  import api from "@/api.js";
  import {
    pagination,
    checktype,
    getlabelbykey,
    goodtype
  } from "@/util/util.js";
  import chooseClassifyDialog from "@/components/dialog/chooseClassifyDialog.vue";

  export default {
    name: "integralList",
    components: {
      chooseClassifyDialog
    },
    data() {
      return {
        defaultprops: {
          value: "id",
          label: "name",
          children: "child"
        },
        formdata: {
          check_type: 0,
          name: "",
          cat_id: [],
          goods_type: 0
        },
        tableData: [],
        page: {
          pageindex: pagination.pageIndex,
          pagesize: pagination.pageSize,
          total: pagination.total
        },
        checktype: checktype,
        goodstype: [
          {
            value: 0,
            label: "全部"
          },
          {
            value: 2,
            label: "实体商品"
          },
          {
            value: 3,
            label: "虚拟商品"
          }
        ],
        multipleSelection: [],
        options: [],
        cateoptions: [],
        ids: "",
        type: "",
        chooseclassifydialog: false
      };
    },
    created() {
      this.querycatelist();
      this.init();
    },
    methods: {
      // 查询分类
      querycatelist() {
        let params = {};
        this.axios
            .post(api.points_goods_cate_list, params)
            .then(response => {
              if (response.data.code == 0) {
                this.cateoptions = this.translatecate(response.data.list || []);
              } else {
              }
            })
            .catch(response => {
            });
      },
      // 转换分类数据
      translatecate(data) {
        if (data && data.length) {
          data.forEach(item => {
            if (item.child && item.child.length) {
              item.child = this.translatecate(item.child);
            } else {
              item.child = null;
            }
          });
        }
        return data;
      },
      //初始化请求
      init() {
        this.page.pageindex = 1;
        this.querylist();
      },
      //查询列表
      querylist() {
        let params = {
          page: this.page.pageindex,
          check_type: this.formdata.check_type,
          goods_type: this.formdata.goods_type,
          name: this.formdata.name,
          cat_id: this.formdata.cat_id[this.formdata.cat_id.length - 1]
        };
        this.axios
            .post(api.points_index, params)
            .then(response => {
              if (response.data.code == 0) {
                this.tableData = response.data.list;
                this.page.total = response.data.all_page;
              } else {
                this.page.total = 0;
              }
            })
            .catch(response => {
            });
      },
      // 分页
      pageIndexChange(pageindex) {
        this.page.pageindex = pageindex;
        this.querylist();
      },
      gettypelabel(type) {
        return getlabelbykey(goodtype, type);
      },
      // 切换状态
      changetype() {
        this.page.pageindex = 1;
        this.querylist();
      },
      // 选择表格行
      handleSelectionChange(val) {
        this.multipleSelection = val;
      },
      // 添加商品
      addgoods() {
        this.$router.push({name: "addOrEditIntegral"});
      },
      // 编辑
      edit(id,type) {
        let query = {id: id,type:1}
        this.$router.push({name: "addOrEditIntegral", query: query});
      },
      // 复制商品
      copy(id) {
        this.$confirm('将为您复制该商品?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.axios
              .post(api.points_copy, {goods_id: id})
              .then(response => {
                if (response.data.code == 0) {
                  this.$message.success("商品复制成功");
                  this.querylist();
                } 
              })
              .catch(response => {
              });   
        }).catch(() => {
        
        });             
      },
      del(id) {
        this.$confirm("是否删除?", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning"
        })
            .then(() => {
              this.sumbitDel(id);
            })
            .catch(() => {
              this.$message({
                type: "warning",
                message: "已取消删除"
              });
            });
      },
      // 删除
      sumbitDel(id) {
        let params = {
          id: id
        };
        this.axios
            .post(api.points_delete, params)
            .then(response => {
              if (response.data.code == 0) {
                this.querylist();
                this.$message({
                  message: "删除成功",
                  type: "success"
                });
              } else {
              }
            })
            .catch(response => {
            });
      },
      // 获取选择的id
      getcheckids() {
        let ids = [];
        if (this.multipleSelection && this.multipleSelection.length > 0) {
          this.multipleSelection.forEach(item => {
            ids.push(item.id);
          });
        }
        return ids.join(",");
      },

      // 批量添加到分类
      batchaddtype() {
        this.ids = this.getcheckids();
        this.type = "A";
        this.chooseclassifydialog = true;
      },
      // 批量操作成功回调
      success() {
        this.querylist();
      },
      // 批量转移到分类
      batchtransfertype() {
        this.ids = this.getcheckids();
        this.type = "M";
        this.chooseclassifydialog = true;
      },
      // 上架
      putonshelves(id) {
        let params = {
          id: [id]
        };
        this.axios
            .post(api.points_up_shelf, params)
            .then(response => {
              if (response.data.code == 0) {
                this.querylist();
                this.$message({
                  message: "上架成功",
                  type: "success"
                });
              } else {
              }
            })
            .catch(response => {
            });
      },
      // 批量上架
      batchputonshelves() {
        let params = {
          id: this.getcheckids()
        };
        this.axios
            .post(api.points_up_shelf, params)
            .then(response => {
              if (response.data.code == 0) {
                this.querylist();
                this.$message({
                  message: "批量上架成功",
                  type: "success"
                });
              } else {
              }
            })
            .catch(response => {
            });
      },
      // 下架
      pulloffshelves(id) {
        let params = {
          id: [id]
        };
        this.axios
            .post(api.points_down_shelf, params)
            .then(response => {
              if (response.data.code == 0) {
                this.querylist();
                this.$message({
                  message: "下架成功",
                  type: "success"
                });
              } else {
              }
            })
            .catch(response => {
            });
      },
      // 批量下架
      batchpulloffshelves() {
        let params = {
          id: this.getcheckids()
        };
        this.axios
            .post(api.points_down_shelf, params)
            .then(response => {
              if (response.data.code == 0) {
                this.querylist();
                this.$message({
                  message: "批量下架成功",
                  type: "success"
                });
              } else {
              }
            })
            .catch(response => {
            });
      },
      // 获取商品物流数量信息
      getlogistics() {
        let result = {
          total: this.multipleSelection.length,
          count: 0
        };
        if (this.multipleSelection && this.multipleSelection.length > 0) {
          this.multipleSelection.forEach(item => {
            if (item.logistics_set == 0) {
              result.count++;
            }
          });
        }
        return result;
      }
    }
  };
</script>

<style scoped>
.shelf_icon{cursor: pointer;}
</style>